export function isSelfOnlyPrivateCapsule(message, uid) {
  const capsuleType = String(message?.capsuleType || "").trim().toLowerCase();
  if (capsuleType && capsuleType !== "private") return false;
  if (!uid || String(message?.senderId || "") !== String(uid)) return false;

  const recipientUserIds = Array.isArray(message?.recipientUserIds)
    ? message.recipientUserIds.filter(Boolean)
    : [];
  const claimedBy = Array.isArray(message?.claimedBy) ? message.claimedBy.filter(Boolean) : [];
  const recipientPhones = Array.isArray(message?.recipientPhoneNumbers)
    ? message.recipientPhoneNumbers.filter(Boolean)
    : [];
  const recipientOnlySelf = recipientUserIds.length > 0 && recipientUserIds.every((id) => id === uid);
  const claimOnlySelf = claimedBy.length > 0 && claimedBy.every((id) => id === uid);

  return (
    message?.isSelfCapsule === true ||
    message?.audience === "self" ||
    (recipientUserIds.length === 1 && recipientUserIds[0] === uid) ||
    recipientOnlySelf ||
    (message?.deliveryMode === "share_claim" && recipientPhones.length === 0 && claimOnlySelf)
  );
}
